import React from "react";


const Language = () => {
    return(
        <div className="skills__content">
                <h3 className="skills__title">Languages</h3>

                <div className="skills__box">
                    <div className="skills group">
                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>

                            <div>
                                <h3 className="skills__name">C++</h3>
                                    <span className="skills__level">Intermediate</span>

                            </div>
                        </div>


                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>

                            <div>
                                <h3 className="skills__name">C#</h3>
                                    <span className="skills__level">Intermediate</span>

                            </div>
                        </div>

                    </div>

                    <div className="skills group">
                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>

                            <div>
                                <h3 className="skills__name">Python</h3>
                                    <span className="skills__level">Intermediate</span>

                            </div>
                        </div>

                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>

                            <div>
                                <h3 className="skills__name">SQL</h3>
                                    <span className="skills__level">Intermediate</span>

                            </div>
                        </div>

                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>

                            <div>
                                <h3 className="skills__name">
                                    HTML, CSS,<br />
                                    JavaScript, PHP
                                </h3>
                                <span className="skills__level">Intermediate</span>

                            </div>
                        </div>
                        
                    </div>
                </div>
        </div>

    )
}

export default Language